import { render, staticRenderFns } from "./AcademicLevels.html?vue&type=template&id=4af5da3c&external"
import script from "./AcademicLevels.js?vue&type=script&lang=js&external"
export * from "./AcademicLevels.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports